import { readonly, ref } from 'vue';

const isHoverExpanded = ref(false);
let hoverExpandTimeout: ReturnType<typeof setTimeout> | null = null;
let hoverCollapseTimeout: ReturnType<typeof setTimeout> | null = null;

function clearSideNavHoverTimers() {
    if (hoverExpandTimeout) {
        clearTimeout(hoverExpandTimeout);
        hoverExpandTimeout = null;
    }

    if (hoverCollapseTimeout) {
        clearTimeout(hoverCollapseTimeout);
        hoverCollapseTimeout = null;
    }
}

function expandSideNavOnHover() {
    clearSideNavHoverTimers();
    hoverExpandTimeout = setTimeout(() => {
        isHoverExpanded.value = true;
        hoverExpandTimeout = null;
    }, 200);
}

function collapseSideNavAfterHover() {
    clearSideNavHoverTimers();
    hoverCollapseTimeout = setTimeout(() => {
        isHoverExpanded.value = false;
        hoverCollapseTimeout = null;
    }, 300);
}

function clearSideNavHover() {
    clearSideNavHoverTimers();
    isHoverExpanded.value = false;
}

export function useSideNavHover() {
    return {
        isHoverExpanded: readonly(isHoverExpanded),
        expandSideNavOnHover,
        collapseSideNavAfterHover,
        clearSideNavHover,
    };
}
